<template>
    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one icon="filter" class="btn-filter" @click="filterWindow"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Código:</label>
                        <input-component :type-input="'text'" v-model="formDate.code"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectStatusProposal"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component
                            :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-0 mt-xxl-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'"/>
                        <button-float class="mx-1" :itens="itensTwo" v-if="buttonCheck.create"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-end'">
                    <div class="toggle_preferences">
                        <button :class="{ 'bg-active': parseInt(cardTable) === 1 }" @click="toggleCard" type="button"
                                tooltip="Card">
                            <i class="window maximize outline icon"></i>
                        </button>
                        <button :class="{ 'bg-active': parseInt(cardTable) === 2 }" @click="toggleTable" type="button"
                                tooltip="Tabela">
                            <i class="align justify icon"></i>
                        </button>
                    </div>
                </row-col-component>
            </row-component>

            <row-component v-if="parseInt(cardTable) === 1">
                <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-4'"
                                   v-for="(data, index) in objectReturn.itens.data" :key="index">
                    <div class="card-container">
                        <div class="flag-status">
                            {{ statusStringProposal(data.status) }}
                        </div>

                        <p>Código: {{ data.code }}</p>
                        <p><strong> {{ data.surname }} </strong></p>

                        <div class="skills">
                            <div class="aux-row-3">
                                <div class="text">
                                    <p><i class="calendar icon"></i>Validade: {{ data.valid }}</p>
                                </div>
                                <div class="text">
                                    <p><i class="money icon"></i>Preço: R$ {{ data.proposed_value }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="responsible-task">
                            <h6> Criador:</h6>
                          <img v-if="data.photo_creator" :src="data.photo_creator" class="avatar__image_2" alt="">
                          <img v-else src="@/assets/img/avatar.png" class="avatar__image_2" alt="">


                          {{ data.creator_user_name }}
                        </div>

                        <div class="buttons">
                            <button tooltip="Editar" class="primary" v-if="buttonCheck.edit"
                                    @click="routeEdit(data.id)">
                                <i class="edit icon"></i>
                            </button>
                        </div>
                    </div>
                </row-col-component>
            </row-component>

            <table class="table table-striped" v-if="parseInt(cardTable) === 2">
                <thead>
                <tr>
                    <th scope="col" style="width: 10%">Código</th>
                    <th scope="col" style="width: 15%">Criador</th>
                    <th scope="col" style="width: 25%">Cliente</th>
                    <th scope="col" style="width: 10%">Validade</th>
                    <th scope="col" style="width: 15%">Preço</th>
                    <th scope="col" style="width: 15%">Status</th>
                    <th scope="col" style="width: 15%" v-if="buttonCheck.edit">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in objectReturn.itens.data" :key="index">
                    <td data-label="Código">{{ data.code }}</td>
                    <td data-label="Criador">

                      <img v-if="data.photo_creator" :src="data.photo_creator" class="avatar__image_2" alt="">
                      <img v-else src="@/assets/img/avatar.png" class="avatar__image_2" alt="">

                      {{ data.creator_user_name }}
                    </td>
                    <td data-label="Cliente">{{ data.client_name }}</td>
                    <td data-label="Validade">{{ data.valid }}</td>
                    <td data-label="Preço">R$ {{ data.proposed_value }}</td>
                    <td data-label="Status">{{ statusStringProposal(data.status) }}</td>
                    <td data-label="Ações" v-if="buttonCheck.edit">
                        <button tooltip="Editar" class="btn btn-success mx-1 button-show" v-if="buttonCheck.edit"
                                @click="routeEdit(data.id)">
                            <i class="edit icon"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="objectReturn.itens" :offset="3" @paginate="loadProposals"/>
        </div>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "ProposalSearch",
    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        InputComponent,
        RowComponent,
        RowColComponent,
        LoderSendComponent,
        Multiselect,
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Proposta')
        this.loadProposals(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/proposal/create",
                icon: "plus",
                name: ''
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formDate: {
                code: '',
                name: '',
                status: '',
                sector: '',
                responsibles: []
            },

            cardTable: '',
            preferences: {
                type: 22,
                preference: ''
            },

            filter: true,
            showLoader: true,
            btnFilter: false,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadProposals(1)
            this.searchSubmit = true;
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },

        routeEdit(id) {
            this.$router.push({name: 'proposal-edit', params: {id: id}})
        },

        toggleTable() {
            this.userPreferences(2)
            this.cardTable = 2
        },

        toggleCard() {
            this.userPreferences(1)
            this.cardTable = 1
        },

        userPreferences(preference) {
            this.preferences.preference = preference
            this.$store.dispatch('userPreferences', this.preferences)
        },

        loadProposals(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadProposals', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        this.cardTable = r.tableCard
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.itens.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 27)
                .then((r) => {
                    if (r.data.indexOf('proposal-search') !== -1) {
                        this.showLoader = false

                        if (r.data.indexOf('proposal-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('proposal-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('proposal-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('proposal-version') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('proposal-approved') !== -1) {
                            this.buttonCheck.create = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        statusStringProposal(status) {
            if (parseInt(status) === 1)
                return "A fazer"
            if (parseInt(status) === 2)
                return "Cadastro"
            if (parseInt(status) === 3)
                return "Enviado para cliente"
            if (parseInt(status) === 4)
                return "Aprovado pelo cliente"
            if (parseInt(status) === 5)
                return "Aprovado pela D7M"
            if (parseInt(status) === 6)
                return "Cancelado"
            if (parseInt(status) === 7)
                return "Nova Versão"
        },
    },

    computed: {
        selectInput() {
            return this.$store.state.var.selectActiveInactive
        },

        selectStatusProposal() {
            return this.$store.state.var.selectStatusProposal
        },

        objectReturn() {
            return this.$store.state.proposal.items
        },

        params() {
            return {
                page: this.objectReturn.current_page,
                code: this.formDate.code,
                name: this.formDate.name,
                status: this.formDate.status,
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>
<style scoped>
.toggle_preferences > button {
    border: 0;
    width: 45px;
    color: #fff;
    height: 45px;
    margin: 0 5px;
    padding-right: 4px;
    border-radius: 50%;
    background-color: #323232;
}

.button-show {
    width: 35px;
    height: 35px;
    font-size: 15px;
    border-radius: 50px;
    padding-left: 0.5rem;
}

.bg-active {
    background-color: #d67c1c !important;
}

.aux-row-3 {
    width: 100%;
    display: flex;
    margin-top: 10px;
    align-items: center;
    margin-bottom: 15px;
    justify-content: space-evenly;
}

.aux-row-3 .text > i {
    color: #7e7e7e;
}

.responsible-task .avatar__image_2 {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid #d67c1c;
}

.responsible-task {
    padding: 15px;
    text-align: left;
    min-height: 80px;
    border-top: 1px solid #ededed;
}

.responsible-task h6 {
    font-size: 14px;
}

.card-container {
    width: 350px;
    color: #2f3032;
    max-width: 100%;
    overflow: hidden;
    margin: 20px auto;
    padding: 40px 0 0;
    position: relative;
    text-align: center;
    background-color: #ffffff;
    border: solid 1px #ededed;
    box-shadow: 10px 10px 15px rgb(0 0 0 / 35%);
}

.card-container p {
    margin: 5px;
}

.card-container p:nth-child(4) {
    font-weight: bold;
}

.buttons {
    width: 100%;
    display: flex;
    min-height: 60px;
    border-top: 1px solid #ededed;
}

button.primary {
    width: 100%;
    height: 60px;
    color: #7e7e7e;
    background-color: #f5f5f5;
    border: 1px solid #fdfdfd;
}

.flag-status {
    top: 0;
    width: 100%;
    color: #ffffff;
    font-size: 14px;
    text-align: left;
    position: absolute;
    padding: 10px 20px;
    background-color: #d67c1c;
    font-family: 'Comfortaa', sans-serif;
}
</style>